var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sucess"},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../../../assets/images/home/success.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("支付成功")]),_vm._v(" "),_c('button',{on:{"click":_vm.toHome}},[_vm._v("回首页")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-193623e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Person/Children/Success.vue
// module id = null
// module chunks = 